import './footer.scss'
import {loadSvg} from 'js/utility/image'

export const component = {
    name: 'footer',

    mounted () {
        this.socials.forEach(social => {
            const url = `${window.__themeUrl}/assets/svg/social/${social.social_icon}`
            loadSvg(url).then(svg => social.icon = svg.outerHTML)
        })
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/footer/footer.js